export interface AccessionData {
    registeredVisitId?: number;
    accessionId?: number;
    accessionNumber?: string;
    sponsorName?: string;
    protocolCode?: string;
    investigatorSiteId?: number;
    investigatorNumber?: string;
    investigatorName?: string;
    subjectId?: string;
    visitName?: string;
    protocolVisitCode?: string;
    visitCollectionDateTime?: any;
    visitCollectionTime?: any;
    protocolVisitDescription?: string;
    visitDescription?: string;
    plannedVisitScheduleId?: number;
    kitType?: string;
    kitTypeId?: number;
    kitDescription?: string;
    subProtocolId?: number;
    kitRequestedOn?: any;
    kitExpiresOn?: any;
    kitboxLabel1?: string;
    kitboxLabel2?: string;
    createdByUserId?: string;
    createdOn?: any;
    submittedByUserId?: string;
    submittedOn?: any;
    projectNumber?: string;
    visitScheduleId?: number;
    patientIdentifier?: string;
    deleteReasonText?: string;
    modifiedOn?: any;
    modifiedByUserId?: string;
    kitTypeRevisionIdBuild?: number;
    kitTypeRevisionIdCurrent?: number;
}

export interface AccessionSearchResult {
    sampleRegistrationAccessionData: AccessionData[];
    errorMsg: string;
    isError: boolean;
}

export interface VisitInfo {
    kitTypeId?: number;
    subprotocolId?: number;
    visitScheduleId?: number;
    protocolVisitCode?: string;
    protocolVisitDescription?: string;
    sequence?: number;
    weekNumber?: number;
    zcProjectNumber?: string;
    rowSelected?: boolean;
}

export const accessionDetailsHeader = [
    {
        displayText: 'Sponsor Name',
        key: 'sponsorName',
    },
    {
        displayText: 'Protocol',
        key: 'protocolCode',
    },
    {
        displayText: 'Investigator Number',
        key: 'investigatorNumber',
    },
    {
        displayText: 'Patient Identifier(s)',
        key: 'patientIdentifier',
    },
    {
        displayText: 'Visit Name',
        key: 'protocolVisitDescription',
    },
    {
        displayText: 'Protocol Visit Code',
        key: 'protocolVisitCode',
    },
    {
        displayText: 'Kit Description',
        key: 'kitDescription',
    },
    {
        displayText: 'Kit type/Kit number',
        key: 'kitType',
    },
    {
        displayText: 'Visit Collection Date',
        key: 'visitCollectionDateTime',
    },
    {
        displayText: 'Visit Collection Time',
        key: 'visitCollectionTime',
    },
];

export enum ErrorMsg {
    NoPermission = 'No Protocol Access - If you need access, please contact your study coordinator.',
    NoAccessionFound = 'Accession Not Found !!',
    MaxBytesError = 'Accession must be 10 digits.',
    OnlyNumberError = 'Accession are numeric values only',
    NonLabCorpKit = 'Value entered is not a LabCorp kit.',
    PermissionRequired = 'Permissions required',
    KitExpired = 'The entered accession is associated with an\nexpired kit. Please replace the expired container and\nindicate use of alternate container on the next page.\nPlease relabel replacement container with accession\nand patient ID.',
    KitUpdated = 'Kit updated',
    AccessRequired = 'Access Required',
    SubmittedSamples = 'Samples for this accession have already been registered.',
    SampleRegisteredForVisitError = 'This accession does not match the selected visit. By proceeding, you confirm that you want to add this sample to the selected visit',
    AdditionalContainerError = 'Sample is a required or optional container. Please indicate collection status above.',
    SampleAlreadyShipped = 'At least one sample for this accession has been added to a shipment',
    PatientError = 'Looks like a patient name',
    InValidBarcode = 'Invalid barcode format'
}

export interface VisitDetailsRequest {
    kitType?: string;
    kitTypeId?: number;
    subprotocolId?: number;
    overrideVisit?: boolean;
}

export interface ReturnContainerInfo {
    registeredContainerId?: number;
    registeredVisitId?: number;
    specimenType?: string;
    accessionNumber?: string;
    containerIdentifier?: string;
    containerId?: number;
    containerNumber?: string;
    barcode?: string;
    projectNumber?: string;
    investigatorSiteNumber?: string;
    returnRequirement?: string;
    label1?: string;
    label2?: string;
    isReturnMandatory?: boolean;
    isBatched?: boolean;
    returnCondition?: string;
    collectionStatus?: string;
    collectionStatusId?: number;
    collected?: boolean;
    notCollectedReason?: string;
    notCollectedReasonId?: number;
    notCollectedOtherReason?: string;
    isAlternateContainer?: boolean;
    alternateContainerDescription?: string;
    alternateContainerReason?: string;
    isAdditionalContainer?: boolean;
    showReason?: boolean;
    children?: ReturnContainerInfo[];
    showOtherReason?: boolean;
    registeredContainerAlternateReasonid?: number;
    registeredContainerAlternateDescription?: number;
    disableLink?: boolean;
}

export interface CollectionStatusData {
    collectionStatusId?: number;
    statusDescription?: string;
    isCollected?: boolean;
    notCollectedReasonId?: number;
    notCollectedReasonDescription?: string;
    isCommentRequired?: boolean;
}

export interface UpdateContainerRequestInfo {
    registeredContainerId?: number;
    registeredContainerCollectionStatusId?: number;
    modifiedon?: any;
    registeredContainerNotCollectedReasonId?: number;
    notCollectedReason?: string;
    registeredContainerAlternateReasonId?: number;
    alternateContainerDescription?: string;
}

export interface AlternateContainerReasonData {
    registeredContainerId?: number;
    registeredContainerCollectionStatusId?: number;
    modifiedon?: any;
    alternateReasonId?: number;
    alternateReasonDescription?: string;
}